<script>
import { Line } from 'vue-chartjs'

export default {
  props: ['responseData'],
  extends: Line,

  methods: {
      setLineColor(lineIndex) {
          const brandInfo = '#003f5c';
          const brandSuccess = '#665191'
          const brandDanger = '#d45087'

          let lineColor = brandInfo;

          if (lineIndex === 1) {
              lineColor = brandSuccess;
          } else if (lineIndex === 2) {
              lineColor = brandDanger;
          } else if (lineIndex === 3) {
              lineColor = '#a05195';
          } else if (lineIndex === 4) {
              lineColor = '#f95d6a';
          } else if (lineIndex === 5) {
              lineColor = '#ffa600';
          }

          return lineColor;
      },

      convertData() {
          function convertHex (hex, opacity) {
              hex = hex.replace('#', '')
              const r = parseInt(hex.substring(0, 2), 16)
              const g = parseInt(hex.substring(2, 4), 16)
              const b = parseInt(hex.substring(4, 6), 16)
              const result = 'rgba(' + r + ',' + g + ',' + b + ',' + opacity / 100 + ')'
              return result
          }
          let chartData = {
              datasets: [],
          }

          this.responseData[0].values.forEach((item, i) => {
              // chartData.labels.push(.unix(item[0]).format("MM/DD/YY"))
            //   chartData.labels.push(.unix(item[0]).format("MM/DD/YYYY - h:mm"))
              // chartData.labels.push(item[0])
          })

          this.responseData.forEach((item, i) => {
              let lineColor = this.setLineColor(i)
              let data = {
                  label: item.metric.label_beta_kubernetes_io_instance_type + ' - ' + item.metric.name,
                  backgroundColor: convertHex(lineColor, 10),
                  borderColor: lineColor,
                  pointHoverBackgroundColor: '#ff7f1f',
                  data: [],
              }
              item.values.forEach((item, i) => {
                  data.data.push(item)
              })
            console.log('item: ' , item)
              chartData.datasets.push(data)
          });

          let chartOptions = {
            plugins: {
      title: {
        display: true,
        text: 'Chart Title',
      }
    },
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                xAxes: [{
                    position: 'bottom',
                    min: 0,
                    beginAtZero: true,
                    // autoSkip: true,
                    ticks: {
                        callback: function(value, index, values) {
                            console.log('values, ' , value);
                            console.log('index, ' , index);
                            console.log('values, ' , values);
                            // Make sure a tick is not a fractional value
                            if (values[index + 1] !== value) {
                                return value;
                            }
                        }
                    }
                }],

                xAxes: {
                    // autoSkip: false,
                    // grid: {
                    //   tickColor: chartData.labels.map((l, i) => i % 3 ? null : 'lightgray')
                    // },
                    // ticks: {
                    //   callback: (t, i) => i % 3 ? '' : labels[i]
                    // },
                },

                xAxes: [{
                  ticks: {
                      // Make labels vertical
                      // https://stackoverflow.com/questions/28031873/make-x-label-horizontal-in-chartjs
                    //   minRotation: 90,

                      // Limit number of labels
                      // https://stackoverflow.com/questions/22064577/limit-labels-number-on-chartjs-line-chart
                      autoSkip: true,
                      maxTicksLimit: 10
                  }
                }],

                yAxes: [{
                    ticks: {
                        beginAtZero: true,
                        stepSize: 1
                    }
                }]
            }
          }
          const marino = chartData.datasets
          console.log('chartDatassssss!!: marino ' ,marino, chartOptions )


          // chartData = {datasets: [{data: [{x: 'Sales', y: 20}, {x: 'Revenue', y: 10}]}]}
          chartOptions = {
            parsing: {
              xAxisKey: 'data\\.key',
              yAxisKey: 'data\\.value'
            }
          }
          this.renderChart(marino, chartOptions)
      },
  },


  mounted() {
    console.log('mounted')
      this.convertData();
  },
}
</script>
